// extracted by mini-css-extract-plugin
module.exports = {"backbtn":"backbutton_backbtn__2VkNY"};